import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import {Container, Form, Button, Alert, Row, Col, Card} from 'react-bootstrap';
import Cookies from "js-cookie";
import {SERVER_BASE_URL} from "../Constants";

const SubmitResult = () => {
    const [workouts, setWorkouts] = useState([]);
    const [selectedWorkout, setSelectedWorkout] = useState('');
    const [scoreValue, setScoreValue] = useState('');
    const [scoreType, setScoreType] = useState('reps');
    const [tieBreaker, setTieBreaker] = useState('');
    const [tieBreakerType, setTieBreakerType] = useState('none');
    const [workoutVariation, setWorkoutVariation] = useState('rx');
    const [tieBreakerDisabled, setTieBreakerDisabled] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const competitionId = location.state?.competitionId;

    useEffect(() => {
        document.title = "Submit Result";
    }, []);

    useEffect(() => {
        console.log(competitionId);
        if (!competitionId) {
            navigate('/profile');
        }

        const fetchWorkouts = async () => {
            try {
                const response = await axios.get(SERVER_BASE_URL + `api/workouts/by-competition/${competitionId}`);
                setWorkouts(response.data);
            } catch (err) {
                setError('Failed to load workouts');
            }
        };

        fetchWorkouts();
    }, [competitionId, navigate]);

    const selectedWorkoutObj = workouts.find(workout => workout.workout_id === parseInt(selectedWorkout));

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("selectedWorkout");
        console.log(selectedWorkout);
        try {

            const token =  Cookies.get("token");
            await axios.post(SERVER_BASE_URL + 'api/results/submit', {
                score_value: scoreValue,
                score_value_type: scoreType,
                tie_breaker: tieBreaker,
                tie_breaker_type: tieBreakerType,
                competition_id: competitionId,
                workout_id: parseInt(selectedWorkout),
                workout_variation: workoutVariation
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            navigate('/profile');
        } catch (err) {
            setError('Failed to submit result');
        }
    };

    return (
        <Container className="d-flex justify-content-center align-items-center p-5">

            <Card style={{ width: "50rem" }}  className="p-4 shadow">
                {error && (<Alert variant="danger">{error}</Alert>)}
                <Card.Body>
                    <h2 className="text-center mb-4">Submit Result</h2>
                    {selectedWorkoutObj && (
                        <Card className="mb-4 mx-auto d-block w-100" style={{ width: "40rem" }}>
                            <Card.Body>
                                <Card.Title className="text-center">{selectedWorkoutObj.workout_name}</Card.Title>
                                <Card.Text className="text-center" style={{ whiteSpace: "pre-line"}}>{selectedWorkoutObj.workout_description}
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    )}


                    <Form onSubmit={handleSubmit}>
                        <Form.Group as={Row} controlId="selectWorkout" className="mb-3">
                            <Form.Label sm="2" column="sm">Select Workout:</Form.Label>
                            <Col sm="10">
                                <Form.Select
                                    size="sm"
                                    value={selectedWorkout}
                                    onChange={(e) => setSelectedWorkout(e.target.value)}
                                    required
                                >
                                    <option value="">Choose...</option>
                                    {workouts.map(workout => (
                                        <option key={workout.workout_id} value={workout.workout_id}>
                                            {workout.workout_name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="scoreValue" className="mb-3">
                            <Form.Label sm="2" column="sm">Score Value:</Form.Label>
                            <Col sm="7">
                                <Form.Control
                                    size="sm"
                                    type="text"
                                    value={scoreValue}
                                    placeholder={scoreType === "time" ? "mm:ss" : "Reps"}
                                    onChange={(e) => setScoreValue(e.target.value)}
                                    required
                                />
                            </Col>
                            <Col sm="3">
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="Reps"
                                    name="scoreType"
                                    value="reps"
                                    checked={scoreType === "reps"}
                                    onChange={(e) => setScoreType(e.target.value)}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="Time"
                                    name="scoreType"
                                    value="time"
                                    checked={scoreType === "time"}
                                    onChange={(e) => setScoreType(e.target.value)}
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="tieBreaker" className="mb-3">
                            <Form.Label sm="2" column="sm">Tie Breaker:</Form.Label>
                            <Col sm="5">
                                <Form.Control
                                    size="sm"
                                    type="text"
                                    value={tieBreaker}
                                    placeholder={tieBreakerType === "time" ? "mm:ss" : tieBreakerType === "reps" ? "Reps" : ""}
                                    disabled={tieBreakerDisabled}
                                    onChange={(e) => {
                                        setTieBreaker(e.target.value)
                                    }}
                                    required
                                />
                            </Col>
                            <Col sm="5">
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="Reps"
                                    name="tieBreakerType"
                                    value="reps"
                                    checked={tieBreakerType === "reps"}
                                    onChange={(e) => {
                                        setTieBreakerType(e.target.value)
                                        setTieBreakerDisabled(false)}}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="Time"
                                    name="tieBreakerType"
                                    value="time"
                                    checked={tieBreakerType === "time"}
                                    onChange={(e) => {
                                        setTieBreakerType(e.target.value)
                                        setTieBreakerDisabled(false)}}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="None"
                                    name="tieBreakerType"
                                    value="none"
                                    checked={tieBreakerType === "none"}
                                    onChange={(e) => {
                                        setTieBreakerType(e.target.value)
                                        e.target.value === "none" ? setTieBreakerDisabled(true) : setTieBreakerDisabled(false)
                                    }}
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="workoutVariation" className="mb-3">
                            <Form.Label sm="3" column="sm">Workout Variation:</Form.Label>

                            <Col sm="3">
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="Rx"
                                    name="workoutVariation"
                                    value="rx"
                                    checked={workoutVariation === "rx"}
                                    onChange={(e) => setWorkoutVariation(e.target.value)}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="Intermediate"
                                    name="workoutVariation"
                                    value="intermediate"
                                    checked={workoutVariation === "intermediate"}
                                    onChange={(e) => setWorkoutVariation(e.target.value)}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="Scaled"
                                    name="workoutVariation"
                                    value="scaled"
                                    checked={workoutVariation === "scaled"}
                                    onChange={(e) => setWorkoutVariation(e.target.value)}
                                />
                            </Col>
                        </Form.Group>
                        <Button type="submit" variant="outline-primary" className="mx-auto d-block">Submit Result</Button>
                    </Form>
                </Card.Body>
            </Card>

        </Container>
    );
};

export default SubmitResult;
